module.exports = __webpack_public_path__ + "img/Wellness@3x.761fdef2.png";